import { useToast } from '../../hooks/useToast';

interface CopyableEmailProps {
  email: string;
}

// Inline email address with a copy-to-clipboard button. Uses <span>/<button>
// only so it stays valid HTML when rendered inside a markdown paragraph.
function CopyableEmail({ email }: CopyableEmailProps) {
  const { showToast } = useToast();

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(email);
      showToast('Copied to clipboard', 'success');
    } catch {
      showToast("Couldn't copy to clipboard", 'error');
    }
  }

  return (
    <span className="docs-inbound-email">
      <code className="docs-code-inline">{email}</code>
      <button
        type="button"
        className="docs-copy-button"
        onClick={handleCopy}
        aria-label={`Copy ${email}`}
      >
        Copy
      </button>
    </span>
  );
}

export default CopyableEmail;
